import { useTheme } from "@/components/providers/use-theme";
import type { Theme } from "@/components/providers/theme-context";
import {
  baseSidebarNavButtonClassName,
  cn,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@cmde/shadcn";
import { MoonIcon, SunIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const SidebarModeToggle = () => {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();
  const mode: Theme = theme === "light" ? "dark" : "light";
  const modeLabel =
    mode === "dark" ? t("components.sidebar.theme.dark") : t("components.sidebar.theme.light");
  const ModeIcon = mode === "dark" ? MoonIcon : SunIcon;

  const handleToggle = (nextMode: Theme) => {
    setTheme(nextMode);
  };

  return (
    <SidebarMenuItem className="w-full">
      <SidebarMenuButton
        variant="nav"
        tooltip={modeLabel}
        aria-label={t("components.sidebar.theme.toggle")}
        data-sidebar-nav="action"
        className={cn(baseSidebarNavButtonClassName, "cursor-pointer")}
        onClick={() => handleToggle(mode)}
      >
        <ModeIcon />
        <span className="truncate">{modeLabel}</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
